import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d90cbda3ffce283117dee0ea30392515.jpg"
          alt="Cosmic Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        
        {/* Subtle Star Pattern Overlay */}
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle, #D4AF37 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-white"
          >
            {/* Small Label */}
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-20 h-px bg-gold"></div>
              <span className="text-xs uppercase tracking-[3px] text-gold font-medium">
                Uzman Spiritüel Danışman
              </span>
            </div>

            {/* Main Heading */}
            <h1 className="font-serif mb-6">
              <div className="text-5xl lg:text-6xl font-light mb-2">
                Yıldızların Dilini
              </div>
              <div className="text-6xl lg:text-7xl font-medium mb-2">
                Ruhunuzun Yolculuğuna
              </div>
              <div className="text-7xl lg:text-8xl font-bold bg-gradient-to-r from-white to-cream bg-clip-text text-transparent">
                Çevirin
              </div>
            </h1>

            {/* Description */}
            <p className="text-base lg:text-lg text-text-light leading-relaxed mb-8 max-w-xl">
              Astrolojik danışmanlık, spiritüel rehberlik ve enerji şifa seanslarıyla 
              kişisel dönüşüm yolculuğunuzda yanınızdayım. 15 yılı aşkın deneyimimle, 
              size özel çözümler sunuyorum.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-6">
              <Link
                to="/randevu"
                className="px-8 py-4 bg-gold text-primary-dark font-semibold rounded-full hover:scale-105 hover:shadow-2xl hover:shadow-gold/50 transition-all duration-300 flex items-center space-x-2 cursor-pointer whitespace-nowrap"
              >
                <span>Randevu Al</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/hizmetler"
                className="px-8 py-4 border-2 border-gold text-gold font-semibold rounded-full hover:bg-gold hover:text-primary-dark transition-all duration-300 flex items-center space-x-2 cursor-pointer whitespace-nowrap"
              >
                <span>Hizmetleri Keşfet</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </motion.div>

          {/* Right Image Card */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative hidden lg:block"
          >
            <div className="relative">
              {/* Glow Effect Behind */}
              <div className="absolute inset-0 bg-gold/30 blur-[100px] rounded-[40px] scale-110"></div>
              
              {/* Main Image Card */}
              <div className="relative rounded-[40px] overflow-hidden shadow-2xl">
                <div className="w-full h-[600px]">
                  <img
                    src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/0c15e7412b31ca3745e64ac30f83ca52.png"
                    alt="Deniz Erin"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/60 via-transparent to-transparent"></div>
                
                {/* Floating Badge */}
                <div className="absolute bottom-8 left-8 px-6 py-3 bg-gold rounded-full shadow-xl">
                  <p className="text-primary-dark font-bold text-sm whitespace-nowrap">
                    15+ Yıl Deneyim
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.8, repeat: Infinity, repeatType: 'reverse' }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
      >
        <div className="w-6 h-10 border-2 border-gold/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-gold rounded-full"></div>
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;